/**
 * Photo represents a photo made from the actual object which was measured, i.e. A photo of the door of the car which is in the shop.
 */
export class Photo {
    public partId?: number;
    public binaryId?: number;
    public mimeType?: string;
}
